import { ApiCallModalType } from "@/src/components/pages/StepPage/components/apiCalls/types";
import { scrollToTop } from "@/src/components/Action/useNavigation";
import { apiCallsModalStore } from "@/src/components/pages/StepPage/components/apiCalls/modalStore";
import { convertToParagraphsAndLists } from "@/src/components/pages/StepPage/components/apiCalls/Modals/AgreementModal";
import { parseLinksAsDOMNode } from "@/src/components/Fields/CheckBox/components/CheckBox";

export function checkExistingContracts(
    isValid: boolean,
    contractsForCancellation: string[],
    pdfLink: string
): Promise<boolean> {
    return new Promise((resolve, reject) => {
        if (!isValid) {
            scrollToTop(true);
            resolve(true);
            return;
        }

        if (!contractsForCancellation.length) {
            resolve(true);
            return;
        }

        const contractsIds =
            contractsForCancellation.length === 1
                ? contractsForCancellation[0]
                : contractsForCancellation.join(', ');

        const description = `Увага! Для цього транспортного засобу знайдено чинний договір Автоцивілки ${contractsIds}.
        Звертаємо Вашу увагу, що укладання нового договору автоматично припинить дію попереднього з моменту початку дії нового договору відповідно до ч. 10 ст. 11 Закону № 3720-IX.
        
        Якщо Ви бажаєте продовжити укладання нового договору, будь ласка, перевірте умови цього та попереднього договорів. Особливу увагу зверніть на правильність таких параметрів:
        
        • строк дії договору
        • VIN-код
        • державний номер
        • марка, модель та рік випуску транспортного засобу
        • особливості та обмеження умов використання транспортного засобу
        
        Інформацію про виявлені договори можна перевірити на веб-сторінці ЦБД МТСБУ: [Перевірка чинності поліса внутрішнього ОСЦПВВТЗ](https://policy.mtsbu.ua)`;


        const convertedDescription = convertToParagraphsAndLists(parseLinksAsDOMNode(description));

        apiCallsModalStore.getState().open(ApiCallModalType.AGREEMENT, {
            title: 'Продовжити укладання договору',
            description: convertedDescription,
            cancelText: 'Відмова',
            confirmText: 'Продовжити укладання договору',
            linkText: 'Детальніше - чому знайдено чинний договір.',

            onConfirmClick: () => {
                resolve(true);
                apiCallsModalStore.getState().close();
            },

            onCancelClick: () => {
                reject(new Error('Action cancelled'));
                apiCallsModalStore.getState().close();
            },

            onLinkClick: ()=>{
                window.open(
                    pdfLink,
                    "_blank",
                    "noopener,noreferrer"
                );
            }
        });
    });
}
